import Swiper from 'swiper';
import { Navigation, Scrollbar, Keyboard } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/keyboard';

document.addEventListener('DOMContentLoaded', function() {
	/**
	 * Slider Functionality
	 *
	 * This module handles the initialisation of carousel slides using
	 * Swiper.js with responsive breakpoints and navigation controls.
	 */
	const blockCarousel = document.querySelector('.blk-carousel');
	if (blockCarousel) {
		/**
		 * Initialises the Swiper instance for the carousel block
		 *
		 * Creates a new Swiper instance with responsive breakpoints,
		 * navigation, keyboard controls, and scrollbar.
		 *
		 * @function initSwiper
		 * @returns {void}
		 */
		function initSwiper() {
			new Swiper(blockCarousel.querySelector('.swiper'), {
				modules: [Navigation, Keyboard, Scrollbar],
				slidesPerView: 1.2,
				spaceBetween: 16,
				breakpoints: {
					640: {
						slidesPerView: 2.2,
					},
					1280: {
						slidesPerView: 3.2,
					},
				},
				allowTouchMove: true,
				keyboard: {
					enabled: true,
				},
				navigation: {
					nextEl: blockCarousel.querySelector('.swiper-button-next'),
					prevEl: blockCarousel.querySelector('.swiper-button-prev'),
				},
				scrollbar: {
					el: blockCarousel.querySelector('.swiper-scrollbar'),
					draggable: true,
				},
			});
		}

		initSwiper();
	}
});
